var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-chip',{attrs:{"color":_vm.statusColor,"text-color":"white"}},[_c('v-avatar',{attrs:{"left":""}},[_c('v-icon',[_vm._v(_vm._s(_vm.statusIcon))])],1),_vm._v(" "+_vm._s(_vm.statusLabel)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }